import Cookies from "js-cookie";
import client from "./axios";
import { AppNotification, NotificationPreferences, NotificationTrigger } from "../models/Notification";

const notificationsUrl = `${window.__env.GATEWAY_URL}/v1/notifications`;
const preferencesUrl = `${window.__env.GATEWAY_URL}/v1/preferences`;
const triggersUrl = `${window.__env.GATEWAY_URL}/v1/notification-triggers`;
const liveNotificationsUrl = `${window.__env.EVENT_GATEWAY_URL}/notifications`;

export interface NotificationPage {
  content: AppNotification[];
  page: number;
  size: number;
  total: number;
}

export const Notifications = {
  listenNotifications: (onMessage: (evt: MessageEvent<any>) => void, onError?: (evt: Event) => void) => {
    const token = Cookies.get(window.__env.AUTH_TOKEN_NAME || "alida-token");
    const url = `${liveNotificationsUrl}/listen?token=${token}`;

    const source = new EventSource(url);
    source.addEventListener('message', onMessage, false);
    if (onError) source.addEventListener('error', onError, false);

    return source;
  },
  stopListening: (source: EventSource) => { if (source) source.close(); },
  getNotifications: (params?: URLSearchParams) => client.get<NotificationPage>(notificationsUrl, { params }),
  getNotification: (id: number) => client.get<AppNotification>(`${notificationsUrl}/${id}`),
  newNotificationsCount: () => client.get(`${notificationsUrl}/new-count`),
  readNotification: (id: number) => client.patch(`${notificationsUrl}/${id}`),
  readNotifications: (params?: URLSearchParams) => client.patch(notificationsUrl, {}, { params }),
  readAllNotifications: () => client.patch(`${notificationsUrl}/all`, {}),
  deleteNotification: (id: number) => client.delete(`${notificationsUrl}/${id}`),
  getNotificationPreferences: () => client.get(preferencesUrl),
  saveNotificationPreferences: (preferences: NotificationPreferences) => client.post<NotificationPreferences>(preferencesUrl, preferences),
  getTriggers: () => client.get<NotificationTrigger[]>(triggersUrl),
  createTrigger: (trigger: NotificationTrigger) => client.post<NotificationTrigger>(triggersUrl, trigger),
  updateTrigger: (trigger: NotificationTrigger) => client.put<NotificationTrigger>(`${triggersUrl}/${trigger.id}`, trigger),
  deleteTrigger: (id: number) => client.delete(`${triggersUrl}/${id}`),
}